export const seasonDivisionKeys = {
	seasonDivisionInfo: (organizationUuid: string, teamLeagueUuid: string, seasonUuid: string, divisionUuid: string) =>
		['SEASON_DIVISION_INFO', organizationUuid, teamLeagueUuid, seasonUuid, divisionUuid] as const
};
